import { _ } from "../../core/polyglot/polyglot.js";
import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `XeroIntegration` is a concrete implementation of `AbstractIntegration`
 * for integration with Xero.
 */
export default class XeroIntegration extends AbstractIntegration {
	getName() {
		return "Xero";
	}

	isBeta() {
		return false;
	}

	routeName() {
		return "xero";
	}

	makeNameLabel(name) {
		return _("Connect to {name}", { name });
	}

	hasInvoiceSupport() {
		return true;
	}

	canBeDisconnected() {
		return true;
	}

	static getType() {
		return "XeroIntegration";
	}
}
